import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../Loader/Loader";

const InfiniteScrollComponent = ({
  dataLength,
  fetchMoreData,
  hasMoreData,
  height,
  loader = true,
  children,
}) => {
  return (
    <InfiniteScroll
      dataLength={dataLength}
      next={fetchMoreData}
      hasMore={hasMoreData}
      height={height}
      loader={
        loader && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader height="5%" width="5%" />
          </div>
        )
      }
      endMessage={
        height === "58vh" && (
          <p style={{ textAlign: "center", margin: "0 0 1rem" }}>
            <b>Yay! You have seen it all</b>
          </p>
        )
      }
    >
      {children}
    </InfiniteScroll>
  );
};

export default InfiniteScrollComponent;
